import { css } from '@emotion/react';

const FONT = `'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const toolbarFiltersCSS = () => css`
    font-family: ${FONT};
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
    margin: 8px 0 16px;
    border-top: 1px solid #EEF1F4;
    border-bottom: 1px solid #EEF1F4;
    flex-wrap: wrap;

    .tf-add-btn {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        height: 30px;
        padding: 0 12px;
        border-radius: 999px;
        border: 1px dashed #CBD5E1;
        background: transparent;
        color: #64748B;
        font-size: 12.5px;
        font-weight: 500;
        font-family: ${FONT};
        cursor: pointer;
        transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
    }
    .tf-add-btn:hover:not(:disabled) {
        border-color: #94A3B8;
        color: #475569;
        background: #F8FAFC;
    }
    .tf-add-btn i { font-size: 11px; }

    .tf-sort {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .tf-sort-label {
        font-size: 12px;
        color: #94A3B8;
    }
    .tf-sort-btn {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: none;
        background: transparent;
        cursor: pointer;
        color: #0F172A;
        font-size: 12.5px;
        font-weight: 600;
        font-family: ${FONT};
        padding: 0;
        opacity: 0.7;
    }
    .tf-sort-btn:disabled { cursor: not-allowed; }
    .tf-sort-btn i { font-size: 11px; color: #94A3B8; }
`;

export const toolbarFilterTagCSS = (active) => css`
    display: inline-flex;
    align-items: center;
    gap: 0;
    height: 30px;
    border-radius: 999px;
    overflow: hidden;
    border: ${active ? '1.5px solid #34C6F1' : '1px solid #EEF1F4'};
    background: #ffffff;
    font-size: 12.5px;
    font-family: ${FONT};
    transition: border-color 0.15s ease;

    .tft-label {
        padding: 0 4px 0 12px;
        color: #94A3B8;
        font-weight: 500;
        white-space: nowrap;
    }
    .tft-value {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        height: 100%;
        padding: 0 4px;
        border: none;
        background: transparent;
        color: ${active ? '#0E6E8E' : '#0F172A'};
        font-size: 12.5px;
        font-weight: ${active ? 600 : 500};
        font-family: ${FONT};
        cursor: pointer;
        white-space: nowrap;
    }
    .tft-value i { font-size: 10px; color: #94A3B8; }
    .tft-clear {
        height: 100%;
        padding: 0 10px 0 2px;
        border: none;
        background: transparent;
        cursor: pointer;
        color: #94A3B8;
        display: inline-flex;
        align-items: center;
        transition: color 0.15s ease;
    }
    .tft-clear:hover { color: #475569; }
    .tft-clear i { font-size: 10px; }
`;

export const toolbarOverlayCSS = () => css`
    font-family: ${FONT};
    min-width: 200px;
    max-width: 280px;
    padding: 6px 4px;

    .tfo-list {
        list-style: none;
        margin: 0;
        padding: 0;
        max-height: 320px;
        overflow-y: auto;
    }
    .tfo-item {
        appearance: none;
        background: transparent;
        border: none;
        width: 100%;
        text-align: left;
        padding: 7px 10px;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: ${FONT};
        font-size: 13px;
        color: #0F172A;
        transition: background 0.12s;
    }
    .tfo-item:hover:not(:disabled) {
        background: #F1F5F9;
    }
    .tfo-item.is-active {
        background: #E3F4FA;
        color: #0E6E8E;
        font-weight: 600;
    }
    .tfo-item i.tfo-check {
        font-size: 11px;
        color: #34C6F1;
        margin-left: auto;
    }
    .tfo-item-sub {
        font-size: 10.5px;
        color: #94A3B8;
        margin-left: auto;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        font-weight: 600;
    }
    .tfo-empty {
        padding: 12px 10px;
        font-size: 12.5px;
        color: #94A3B8;
        text-align: center;
    }
`;
